import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-scora-no-data',
  templateUrl: './scora-no-data.component.html',
  styleUrls: ['./scora-no-data.component.css']
})
export class ScoraNoDataComponent implements OnInit {
  @Input() version:any;
  @Input() configData:any;

  constructor(private router: Router) { }

  ngOnInit() {
    // {image:'no-data-v1', message:"It looks like you don't have any data yet.<br>Click 'Add' to get started!" , isButton:true, url:'/scora-test-admin/test-bank/create-test-bank'}
  }


  addEvent(url){
      this.router.navigate([url])
  }
  // home_url

  cancelEvent(url){
    this.router.navigate([url])
}

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-common-module/scora-no-data/scora-no-data.component.ts